import PageContent from "components/Page/Content";
import { useUserStore } from "store/User";
import DashboardDecisionSearch from "./components/DecisionSearch";

export default function Dashboard() {
  const user = useUserStore((state) => state.user);

  return (
    <PageContent
      title={`Hi ${user?.firstName}, welcome to your Abound Dashboard`}
    >
      <div className="flex flex-col space-y-8">
        <DashboardDecisionSearch />
      </div>
    </PageContent>
  );
}
